<div
  class="slide-toggle"
  [ngClass]="type === 'boxFirst' ? 'box-first' : 'label-first'"
>
  <label *ngIf="label" for="{{ id }}">{{ label }}</label>
  <div class="input-box theme-{{ theme }}" (click)="onToggleClick($event)">
    <ng-content select="input[type='checkbox']"></ng-content>
  </div>
</div>
